import { render } from "./createservice.vue?vue&type=template&id=5d7f7870"
import script from "./createservice.vue?vue&type=script&lang=js"
export * from "./createservice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__